import Skeleton from '@mui/material/Skeleton';
import React from 'react';

import LoadingStateWrapper from '@swf/sports/components/LoadingStateWrapper/LoadingStateWrapper';

import styles from './LoadingState.scss';

const PopularAccumulatorsLoadingState: React.FC = () => (
  <LoadingStateWrapper>
    <div className={styles.wrapper}>
      <Skeleton variant="rectangular" height="48px" width="100%" animation={false} />
      <div className={styles.cardWrapper}>
        <Skeleton className={styles.card} variant="rectangular" height="365px" />
      </div>
    </div>
  </LoadingStateWrapper>
);

export default PopularAccumulatorsLoadingState;
